/* Sunne v2 – svenska och mobilanpassningar i IzyRents kalender.

   TRE JOBB. Alla tre finns för att appens egen mobilkalender är svår att
   använda, och 94 % av köpen sker på mobil.

   1. SVENSKA PLATSHÅLLARE. IzyRent ritar sina egna platshållare på engelska när
      produktens Labels inte är ifyllda i appen. "Start Day" och "End Day" stod
      kvar på alla boenden och ställplatser. Appen ritar om widgeten flera
      gånger efter sidladdning, därför en vakt.

      Rätt ställe att fixa detta på är egentligen IzyRents produktformulär
      (Labels), men appfönstret i adminen går inte alltid att styra. När en
      produkt fått svenska etiketter i appen gör den här delen ingenting.

   2. KLAR-KNAPP. På skärmar under 900 px öppnar appen kalendern som en
      helskärmsruta. Enda vägen ut är ett litet kryss uppe till vänster, och
      appens egen rad med Rensa och Spara ligger på display: none i det läget.
      Rapporterat 8 september 2026: kunden trycker på 26 december och kommer
      inte vidare – krysset uppfattas inte som "klar".

      Vi lägger därför in en egen knapp, men bara när appens egen knapprad är
      dold. Knappen klickar på appens kryss, så allt appen gör vid stängning
      sker precis som vanligt.

   3. BLÄDDRA I SIDLED. Appen lägger tretton månader under varandra i en lång
      rulle. Att ta sig från september till 26 december betydde fyra skärmar
      scroll. Strukturen är enkel: .flatpickr-days har ett barn per månad,
      div.mobileCal, med rubrik, veckodagar och dagrutnät i sig. Vi lägger dem
      i rad i stället för i kolumn och sätter scroll-snap, så blir varje månad
      en egen sida att svepa mellan. Pilar finns för den som hellre trycker.

      TRE BREDDER MÅSTE NOLLAS för att detta ska fungera. Appen sätter
      .flatpickr-days och .flatpickr-rContainer till hela multiMonth-bredden
      (13 × 307,875 = 4002 px). Med kolumnlayout syntes det inte, men i rad
      blir varje månad 4002 px bred och kalendern ser tom ut. Därför tvingas
      .flatpickr-innerContainer, .flatpickr-rContainer och .flatpickr-days till
      100 %. Rör inte de raderna utan att kontrollera på telefon efteråt.

      Månaderna är färdigrenderade även när appen märkt dem "unshown", så
      inget innehåll saknas när man bläddrar.

   STILEN LIGGER I DEN HÄR FILEN, inte i sunne-izyrent.css, för att allt som
   rör mobilkalendern ska gå att läsa på ett ställe. Flyttas den någon gång:
   ta med kommentarerna.

   Testa alltid på telefon efter en ändring här. */
(function () {
  'use strict';

  var SMAL = 899;

  /* --- 1. Svenska platshållare ------------------------------------------- */

  var ordbok = {
    'Start Day': 'Ankomst',
    'End Day': 'Avresa',
    'Book your days': 'Välj dagar',
    'Select date': 'Välj datum',
    'Select a date': 'Välj datum',
    'Choose a date': 'Välj datum'
  };

  function fixaSprak() {
    var falt = document.querySelectorAll('input.izyDate, #startDate, #endDate');
    for (var i = 0; i < falt.length; i++) {
      var p = falt[i].getAttribute('placeholder');
      if (p && ordbok[p]) { falt[i].setAttribute('placeholder', ordbok[p]); }
    }
  }

  /* --- Gemensamt --------------------------------------------------------- */

  function syns(el) {
    if (!el) { return false; }
    if (el.offsetParent === null) { return false; }
    var s = window.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden';
  }

  function taBort(id) {
    var el = document.getElementById(id);
    if (el && el.parentNode) { el.parentNode.removeChild(el); }
  }

  /* Leta inte efter klassen .open. Rapporterat 14 september 2026: på Hyra
     skidor, som står i läget Multiple, är kalendern uppslagen i helskärm utan
     att bära .open, och knappraden uteblev därför helt. Vi tar i stället den
     första kalender som verkligen syns och är stor nog att vara helskärms-
     rutan. izyCal först, vanlig flatpickr som reserv. */
  function oppenKalender() {
    if (window.innerWidth > SMAL) { return null; }
    var kandidater = document.querySelectorAll(
      '.flatpickr-calendar.izyCal, .flatpickr-calendar'
    );
    for (var i = 0; i < kandidater.length; i++) {
      var k = kandidater[i];
      var s = window.getComputedStyle(k);
      if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') { continue; }
      var r = k.getBoundingClientRect();
      if (r.height > 160 && r.width > 160) { return k; }
    }
    return null;
  }

  /* Stängningen går alltid genom appens egen knapp när den finns, så allt
     appen gör vid stängning sker som vanligt. Reserverna är till för
     produkter där knappen har ett annat id än på boendena. */
  function stangKalender() {
    var kal = oppenKalender();
    if (!kal) { return; }
    var stang = kal.querySelector('#izyClose') || kal.querySelector('.izyClose');
    if (stang) { stang.click(); return; }
    var falt = document.querySelector('input.izyDate, #startDate, #endDate');
    if (falt && falt._flatpickr && typeof falt._flatpickr.close === 'function') {
      falt._flatpickr.close();
      return;
    }
    kal.classList.remove('open');
  }

  function antalValda(kal) {
    return kal.querySelectorAll(
      '.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange'
    ).length;
  }

  /* --- Stil för mobilkalendern ------------------------------------------- */

  function stil() {
    if (document.getElementById('sv2-izy-mobilstil')) { return; }
    var s = document.createElement('style');
    s.id = 'sv2-izy-mobilstil';
    s.textContent =
      '@media (max-width:' + SMAL + 'px){' +

      /* Nollställ appens multiMonth-bredder. Se kommentaren i filens huvud. */
      'body .flatpickr-calendar.izyCal .flatpickr-innerContainer,' +
      'body .flatpickr-calendar.izyCal .flatpickr-rContainer{' +
      'width:100% !important;max-width:100% !important;min-width:0 !important;}' +
      'body .flatpickr-calendar.izyCal .flatpickr-innerContainer{overflow:hidden !important;}' +

      /* En månad per sida, svep i sidled. */
      'body .flatpickr-calendar.izyCal .flatpickr-days{' +
      'width:100% !important;max-width:100% !important;' +
      'flex-direction:row !important;flex-wrap:nowrap !important;' +
      'overflow-x:auto !important;overflow-y:hidden !important;' +
      'scroll-snap-type:x mandatory;scroll-behavior:smooth;' +
      'scrollbar-width:none;-ms-overflow-style:none;}' +
      'body .flatpickr-calendar.izyCal .flatpickr-days::-webkit-scrollbar{display:none;}' +
      'body .flatpickr-calendar.izyCal .flatpickr-days > .mobileCal{' +
      'flex:0 0 100% !important;width:100% !important;max-width:100% !important;' +
      'scroll-snap-align:start;}' +
      'body .flatpickr-calendar.izyCal .mobileCal .dayContainer{' +
      'width:100% !important;max-width:100% !important;min-width:0 !important;}' +

      /* Pilpar uppe till höger, i höjd med månadsrubriken. Rapporterat
         14 september 2026: kunden förstår inte att månaderna ligger i sidled
         och att man sveper mellan dem. Pilarna sitter i par i högerkanten och
         inte en i vardera kant, eftersom appens stängkryss upptar vänstra
         hörnet och rubriken ligger centrerad mellan dem. */
      '#sv2-izy-topp{position:fixed;right:10px;display:flex;gap:6px;}' +
      '#sv2-izy-topp button{font:inherit;border:0;cursor:pointer;border-radius:8px;' +
      'width:40px;height:40px;display:flex;align-items:center;justify-content:center;' +
      'background:#14324c;color:#ffffff;font-size:22px;font-weight:700;line-height:1;' +
      'box-shadow:0 4px 14px rgba(7,7,7,.2);}' +
      '#sv2-izy-topp button[disabled]{opacity:.3;pointer-events:none;}' +

      /* Knappraden: pil, Klar, pil. Toppen sätts från JavaScript, direkt
         under dagrutnätet. */
      '#sv2-izy-bar{position:fixed;left:12px;right:12px;' +
      'display:flex;align-items:stretch;gap:8px;}' +
      '#sv2-izy-bar button{font:inherit;border:0;cursor:pointer;border-radius:8px;' +
      'min-height:52px;display:flex;align-items:center;justify-content:center;' +
      'box-shadow:0 6px 20px rgba(7,7,7,.25);}' +
      '#sv2-izy-bar .sv2-izy-pil{flex:0 0 52px;background:#fffdfd;color:#14324c;' +
      'font-size:24px;font-weight:700;line-height:1;}' +
      '#sv2-izy-bar .sv2-izy-pil[disabled]{opacity:.4;pointer-events:none;}' +
      '#sv2-izy-bar .sv2-izy-klar{flex:1 1 auto;background:#94cba9;color:#14324c;' +
      'font-size:17px;font-weight:700;padding:12px 20px;}' +
      '}';
    document.head.appendChild(s);
  }

  /* Kalendern kan ligga på vilket z-index som helst. Lägger vi oss lägre
     hamnar knapparna bakom den och syns inte alls – det var felet 14
     september 2026, när raden flyttades ut till body. Läs av och lägg dig
     över. */
  function overKalendern(el, kal, plus) {
    var z = parseInt(window.getComputedStyle(kal).zIndex, 10);
    if (isNaN(z)) { z = 99999; }
    el.style.zIndex = String(z + plus);
  }

  /* Flatpickr stänger kalendern när den ser ett klick utanför den. Ligger
     knapparna i body är varje tryck på en pil ett sådant klick, och rutan
     åkte ner i stället för att bläddra – rapporterat 14 september 2026.
     Knapparna hänger därför i kalendern igen, och för säkerhets skull
     stoppas händelsen från att bubbla vidare till dokumentet. Lyssnaren
     ligger i bubbelfasen, inte capture, så knappens egen klickhanterare
     hinner köra först. */
  function stoppaBubbla(el) {
    var namn = ['pointerdown', 'mousedown', 'touchstart', 'click'];
    for (var i = 0; i < namn.length; i++) {
      el.addEventListener(namn[i], function (e) { e.stopPropagation(); });
    }
  }

  /* --- Pilparet uppe till höger ------------------------------------------ */

  function toppilar(kal, dagar) {
    var t = document.getElementById('sv2-izy-topp');
    if (!t || t.parentNode !== kal) {
      taBort('sv2-izy-topp');
      t = document.createElement('div');
      t.id = 'sv2-izy-topp';

      var v = document.createElement('button');
      v.type = 'button';
      v.textContent = '‹';
      v.setAttribute('aria-label', 'Föregående månad');

      var h = document.createElement('button');
      h.type = 'button';
      h.textContent = '›';
      h.setAttribute('aria-label', 'Nästa månad');

      v.addEventListener('click', function (e) {
        e.preventDefault();
        var d = t.__dagar;
        if (d) { d.scrollBy({ left: -d.clientWidth, behavior: 'smooth' }); }
      });
      h.addEventListener('click', function (e) {
        e.preventDefault();
        var d = t.__dagar;
        if (d) { d.scrollBy({ left: d.clientWidth, behavior: 'smooth' }); }
      });

      t.appendChild(v);
      t.appendChild(h);
      stoppaBubbla(t);
      kal.appendChild(t);
    }

    t.__dagar = dagar;

    /* Placeras i höjd med månadsrubriken. Rubriken ligger inne i varje
       månadsruta och scrollar med i sidled, därför mäter vi den första och
       låser pilarna på den höjden i stället för att följa med. */
    var ref = kal.querySelector('.mobileCal') || dagar;
    var r = ref.getBoundingClientRect();
    var topp = Math.max(8, Math.round(r.top + 2));
    t.style.top = topp + 'px';
    overKalendern(t, kal, 2);

    lagePilar(t.querySelectorAll('button'), dagar);
  }

  /* --- Knappraden -------------------------------------------------------- */

  function bar(kal) {
    var dagar = kal.querySelector('.flatpickr-days');
    if (!dagar) { taBort('sv2-izy-bar'); return; }

    var appensRad = syns(kal.querySelector('#izyCalButtons'));

    /* Raden hänger i kalendern, inte i body. Se kommentaren vid
       stoppaBubbla. Knapparna är position: fixed, så de klipps inte av
       kalenderns overflow. */
    var b = document.getElementById('sv2-izy-bar');
    if (!b || b.parentNode !== kal) {
      taBort('sv2-izy-bar');
      b = document.createElement('div');
      b.id = 'sv2-izy-bar';

      var bak = document.createElement('button');
      bak.type = 'button';
      bak.className = 'sv2-izy-pil';
      bak.textContent = '‹';
      bak.setAttribute('aria-label', 'Föregående månad');

      var klar = document.createElement('button');
      klar.type = 'button';
      klar.className = 'sv2-izy-klar';
      klar.textContent = 'Klar';

      var fram = document.createElement('button');
      fram.type = 'button';
      fram.className = 'sv2-izy-pil';
      fram.textContent = '›';
      fram.setAttribute('aria-label', 'Nästa månad');

      bak.addEventListener('click', function (h) {
        h.preventDefault();
        var d = b.__dagar;
        if (d) { d.scrollBy({ left: -d.clientWidth, behavior: 'smooth' }); }
      });
      fram.addEventListener('click', function (h) {
        h.preventDefault();
        var d = b.__dagar;
        if (d) { d.scrollBy({ left: d.clientWidth, behavior: 'smooth' }); }
      });
      klar.addEventListener('click', function (h) {
        h.preventDefault();
        stangKalender();
        stad();
      });

      b.appendChild(bak);
      b.appendChild(klar);
      b.appendChild(fram);
      stoppaBubbla(b);
      kal.appendChild(b);
    }

    /* Kalendern byts ut när appen ritar om. Peka om raden mot det nya
       dagrutnätet i stället för att bygga hela raden på nytt. */
    if (b.__dagar !== dagar) {
      b.__dagar = dagar;
      dagar.addEventListener('scroll', function () {
        clearTimeout(dagar.__sv2t);
        dagar.__sv2t = setTimeout(function () { lage(b, dagar); }, 120);
      });
    }

    /* Visar appen sin egen rad – bastun – hoppar vi över Klar och lämnar
       kvar bara pilarna. */
    var klarKnapp = b.querySelector('.sv2-izy-klar');
    klarKnapp.hidden = appensRad;
    /* Knappen stänger alltid, men texten ska inte lova ett val som inte
       finns. Inga valda dagar: Stäng. Valda dagar: Klar. */
    klarKnapp.textContent = antalValda(kal) > 0 ? 'Klar' : 'Stäng';

    /* Raden ligger direkt under dagrutnätet, inte mot skärmens nederkant.
       Mät INTE .flatpickr-days: appen sträcker den till nästan hela
       skärmhöjden, så dess underkant ligger längst ner även när sista
       veckoraden slutar högt upp. Rätt element är .dayContainer i den månad
       som syns just nu. */
    var manader = dagar.querySelectorAll('.mobileCal');
    var idx = Math.round(dagar.scrollLeft / (dagar.clientWidth || 1));
    var iVy = manader[idx] || manader[0];
    var ruta = (iVy && iVy.querySelector('.dayContainer')) || iVy || dagar;
    var rd = ruta.getBoundingClientRect();
    var under = Math.round(rd.bottom + 14);
    var tak = window.innerHeight - 76;
    b.style.top = Math.min(under, tak) + 'px';

    overKalendern(b, kal, 1);
    lage(b, dagar);
  }

  function lage(b, dagar) {
    lagePilar(b.querySelectorAll('.sv2-izy-pil'), dagar);
  }

  function lagePilar(pilar, dagar) {
    if (!pilar || pilar.length < 2) { return; }
    var max = dagar.scrollWidth - dagar.clientWidth - 4;
    pilar[0].disabled = dagar.scrollLeft <= 4;
    pilar[1].disabled = dagar.scrollLeft >= max;
  }

  /* Kalendern öppnar på innevarande månad även när hela den månaden är
     stängd. I september 2026 betyder det tre svep innan kunden ser något
     valbart, eftersom säsongen börjar 26 december. Vi hoppar dit direkt,
     en gång per öppning. */
  function hoppaTillForstaLediga(dagar) {
    if (dagar.__sv2hoppat) { return; }
    if (!dagar.clientWidth) { return; }
    var manader = dagar.querySelectorAll('.mobileCal');
    if (!manader.length) { return; }
    for (var i = 0; i < manader.length; i++) {
      var ledig = manader[i].querySelector(
        '.flatpickr-day:not(.flatpickr-disabled):not(.notAllowed):not(.prevMonthDay):not(.nextMonthDay):not(.hidden)'
      );
      if (ledig) {
        dagar.__sv2hoppat = true;
        if (i > 0) { dagar.scrollLeft = i * dagar.clientWidth; }
        return;
      }
    }
    dagar.__sv2hoppat = true;
  }

  function stad() {
    taBort('sv2-izy-bar');
    taBort('sv2-izy-topp');
  }

  /* Diagnostik. Öppna sidan med ?sv2debug=1 så ritas en ruta med precis det
     vi behöver veta när knapparna uteblir. Den går att skärmdumpa, vilket
     console.log inte gör på en telefon. Utan parametern gör den ingenting. */
  function debugruta() {
    if (window.location.search.indexOf('sv2debug') === -1) { return; }
    var d = document.getElementById('sv2-izy-debug');
    if (!d) {
      d = document.createElement('div');
      d.id = 'sv2-izy-debug';
      d.style.cssText = 'position:fixed;left:6px;top:6px;z-index:2147483647;' +
        'background:#14324c;color:#fff;font:12px/1.45 monospace;padding:8px 10px;' +
        'border-radius:8px;max-width:72vw;white-space:pre-wrap;pointer-events:none;';
      document.body.appendChild(d);
    }
    var kal = oppenKalender();
    var b = document.getElementById('sv2-izy-bar');
    var t = document.getElementById('sv2-izy-topp');
    var rad = [];
    rad.push('bredd ' + window.innerWidth);
    rad.push('flatpickr ' + document.querySelectorAll('.flatpickr-calendar').length +
             ' izyCal ' + document.querySelectorAll('.flatpickr-calendar.izyCal').length);
    rad.push('hittad ' + (kal ? 'ja' : 'NEJ'));
    if (kal) {
      var r = kal.getBoundingClientRect();
      rad.push('kal z' + window.getComputedStyle(kal).zIndex +
               ' ' + Math.round(r.width) + 'x' + Math.round(r.height));
      rad.push('days ' + (kal.querySelector('.flatpickr-days') ? 'ja' : 'NEJ'));
    }
    rad.push('bar ' + (b ? 'z' + b.style.zIndex + ' top' + Math.round(b.getBoundingClientRect().top) : 'SAKNAS'));
    rad.push('topp ' + (t ? 'z' + t.style.zIndex + ' top' + Math.round(t.getBoundingClientRect().top) : 'SAKNAS'));
    d.textContent = rad.join('\n');
  }

  function svep() {
    fixaSprak();
    var kal = oppenKalender();
    if (!kal) { stad(); debugruta(); return; }
    stil();
    var dagar = kal.querySelector('.flatpickr-days');
    if (dagar) { hoppaTillForstaLediga(dagar); }
    bar(kal);
    if (dagar) { toppilar(kal, dagar); }
    debugruta();
  }

  function start() {
    svep();
    /* Kalendern öppnas långt efter sidladdning, så kollen får löpa vidare.
       Arbetet är en handfull frågor mot DOM:en var 400:e ms. */
    setInterval(svep, 400);
    window.addEventListener('resize', svep);
    document.addEventListener('izyrentAfterAddToCart', fixaSprak);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();